import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import Header from './components/Header';
import Body from './components/Body';
import About from './components/About';
import Error from './components/Error';
import Footer from './components/Footer';
import WhatsappButton from './components/WhatsappButton';

const Contact = lazy(() => import('./components/Contact'));
const Blog = lazy(() => import('./components/Blog'));
const BlogPost = lazy(() => import('./components/BlogPost'));

const AppLayout = () => {
    return (
        <div className='app'>
            <Header />
            <Suspense fallback={<div className='page-loading'>Loading...</div>}>
                <Outlet />
            </Suspense>
            <Footer />
            <WhatsappButton />
        </div>
    );
};

const appRouter = createBrowserRouter([
    {
        path: '/',
        element: <AppLayout />,
        errorElement: <Error />,
        children: [
            {
                path: '/',
                element: <Body />,
            },
            {
                path: '/about',
                element: <About />,
            },
            {
                path: '/contact',
                element: <Contact />,
            },
            {
                path: '/blog',
                element: <Blog />,
            },
            {
                path: '/blog/:slug',
                element: <BlogPost />,
            },
        ],
    },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<RouterProvider router={appRouter} />);
